import './_hotspots.scss';

import 'snippets/video-player/video-block';
import 'snippets/_containers/modal/modal';

window.addEventListener('DOMContentLoaded', function() {
    const hotspotComponents = document.querySelectorAll('.hotspots');

    hotspotComponents.forEach(hotspotComponent => {

        const hotspotButtons = hotspotComponent.querySelectorAll('.hotspot__button');
    
        function handleNextHotspot() {
            const hotspotButtons = [...hotspotComponent.querySelectorAll('.hotspot__button')];
            const activeHotspotButton = hotspotComponent.querySelector('.hotspot__button--active');
            const activeHotspotIndex = parseInt(activeHotspotButton?.dataset.hotspotIndex);
            
            if (activeHotspotIndex == hotspotButtons.length - 1) {
                const newHotspotData = JSON.parse(hotspotButtons[0]?.dataset.hotspot);
                displayHotspotInfo(newHotspotData);
                updateActiveHotspot(0);
            } else {
                const newHotspotIndex = activeHotspotIndex + 1;
                const newHotspotData = JSON.parse(hotspotButtons[newHotspotIndex]?.dataset.hotspot);
                displayHotspotInfo(newHotspotData);
                updateActiveHotspot(newHotspotIndex);
            }
        }
    
        function handlePreviousHotspot() {
            const hotspotButtons = [...hotspotComponent.querySelectorAll('.hotspot__button')];
            const activeHotspotButton = hotspotComponent.querySelector('.hotspot__button--active');
            const activeHotspotIndex = parseInt(activeHotspotButton?.dataset.hotspotIndex);
            
            if (activeHotspotIndex == 0) {
                const newHotspotIndex = hotspotButtons.length - 1;
                const newHotspotData = JSON.parse(hotspotButtons[newHotspotIndex]?.dataset.hotspot);
                displayHotspotInfo(newHotspotData);
                updateActiveHotspot(newHotspotIndex);
            } else {
                const newHotspotIndex = activeHotspotIndex - 1;
                const newHotspotData = JSON.parse(hotspotButtons[newHotspotIndex]?.dataset.hotspot);
                displayHotspotInfo(newHotspotData);
                updateActiveHotspot(newHotspotIndex);
            }
        }
    
        function generateSourceList(replaceUrl, srcSet, newImage) {
            const srcArray = srcSet.split(',');
            const newSourceList = srcArray.reduce((string, source, index) => {
                
                string += `${source.replace(replaceUrl, newImage)}`;
    
                if (index < srcArray.length - 1) {
                    string += ',';
                }
    
                return string;
            }, '');
    
            return newSourceList;
        }
    
        function displayHotspotInfo(hotspotData) {
            const activeHotspot = hotspotComponent.querySelector('.active-hotspot');
            if (!activeHotspot) return; // Exit if activeHotspot is not found
        
            const { title, description, image, badge, video_url } = hotspotData;
        
            // Update title and description
            const titleContainer = activeHotspot.querySelector('.active-hotspot__title');
            if (titleContainer) titleContainer.textContent = title;
        
            const descriptionContainer = activeHotspot.querySelector('.active-hotspot__description');
            if (descriptionContainer) descriptionContainer.textContent = description;
        
            // Update image
            const imageContainer = activeHotspot.querySelector('.active-hotspot__image-wrapper');
            if (imageContainer) {
                const imageSourceLists = imageContainer.querySelectorAll('source');
                const imageContainerImage = imageContainer.querySelector('img');
        
                if (imageContainerImage) {
                    let currentImageURL = new URL(imageContainerImage.src);
                    currentImageURL.searchParams.delete('width');
                    currentImageURL = currentImageURL.toString().replace('https:', '');
        
                    const inlineSourceList = imageContainerImage.getAttribute('srcset');
                    imageContainerImage.setAttribute('srcset', generateSourceList(currentImageURL, inlineSourceList, image));
                    imageContainerImage.src = image;
        
                    imageSourceLists.forEach(sourceList => {
                        const sourceSet = sourceList.getAttribute('srcset');
                        sourceList.setAttribute('srcset', generateSourceList(currentImageURL, sourceSet, image));
                    });
                }
            }
        
            // Update badge
            const badgeContainer = activeHotspot.querySelector('.active-hotspot__badge-wrapper');
            if (badgeContainer) {
                const badgeSourceLists = badgeContainer.querySelectorAll('source');
                const badgeContainerImage = badgeContainer.querySelector('img');
        
                if (badge && badgeContainerImage) {
                    let currentBadgeURL = new URL(badgeContainerImage.src);
                    currentBadgeURL.searchParams.delete('width');
                    currentBadgeURL = currentBadgeURL.toString().replace('https:', '');
        
                    const badgeSourceList = badgeContainerImage.getAttribute('srcset');
                    badgeContainerImage.src = badge;
                    badgeContainerImage.setAttribute('srcset', generateSourceList(currentBadgeURL, badgeSourceList, badge));
        
                    badgeSourceLists.forEach(sourceList => {
                        const sourceSet = sourceList.getAttribute('srcset');
                        sourceList.setAttribute('srcset', generateSourceList(currentBadgeURL, sourceSet, badge));
                    });
        
                    badgeContainer.style.display = 'block';
                } else {
                    badgeContainer.style.display = 'none';
                }
            }
        
            // Update video
            const videoElement = activeHotspot.querySelector('video');
            const videoButton = activeHotspot.querySelector('.active-hotspot__button');
            const hotspotLower = activeHotspot.querySelector('.active-hotspot__lower');
        
            if (video_url) {
                if (videoButton) videoButton.style.display = 'inline-flex';
        
                if (hotspotLower && !hotspotLower.classList.contains('active-hotspot__lower--has-video')) {
                    hotspotLower.classList.add('active-hotspot__lower--has-video');
                }
        
                if (videoElement) {
                    const videoSources = videoElement.querySelectorAll('source');
                    videoSources.forEach(source => source.remove());
        
                    if (window.location.href.includes('/products')) {
                        const newSourceElement = document.createElement('source');
                        let mimeType = video_url.includes('.webm') ? 'video/webm' :
                                       video_url.includes('.ogv') ? 'video/ogg' : 'video/mp4';
        
                        newSourceElement.setAttribute('src', video_url);
                        newSourceElement.setAttribute('type', mimeType);
                        videoElement.appendChild(newSourceElement);
                    } else if (hotspotData.video_url.sources) {
                        hotspotData.video_url.sources.forEach(source => {
                            const newSourceElement = document.createElement('source');
                            newSourceElement.setAttribute('src', source.url);
                            newSourceElement.setAttribute('type', source.mime_type);
                            videoElement.appendChild(newSourceElement);
                        });
                    }
        
                    const posterImage = `https:${image}&width=1200`;
                    videoElement.setAttribute('poster', posterImage);
                    videoElement.load();
        
                    const videoBlock = activeHotspot.querySelector('.video-block');
                    if (videoBlock) {
                        videoBlock.style.backgroundImage = `url(${posterImage})`;
                        videoBlock.style.backgroundPosition = '50% 50%';
                    }
                }
            } else {
                if (videoButton) videoButton.style.display = 'none';
        
                if (hotspotLower && hotspotLower.classList.contains('active-hotspot__lower--has-video')) {
                    hotspotLower.classList.remove('active-hotspot__lower--has-video');
                }
            }
        }
    
        function updateActiveHotspot(index) {
            const activeHotspotButton = hotspotComponent.querySelector('.hotspot__button.hotspot__button--active');
            activeHotspotButton.classList.remove('hotspot__button--active');
    
            hotspotButtons[index].classList.add('hotspot__button--active'); 
        }
    
        if (hotspotButtons !== null) {
            hotspotButtons.forEach((hotspotButton, index) => {
                const hotspotData = JSON.parse(hotspotButton?.dataset.hotspot);
                hotspotButton.addEventListener('click', function() {
                    displayHotspotInfo(hotspotData, index, hotspotButtons.length);
                    updateActiveHotspot(index);
                });
            });
        }
    
        const hotspotPrevButton = hotspotComponent.querySelector('.active-hotspot__pagination-button--prev');
        if (hotspotPrevButton !== null) {
            hotspotPrevButton.addEventListener('click', function() {
                handlePreviousHotspot();
            });
        }
    
        const hotspotNextButton = hotspotComponent.querySelector('.active-hotspot__pagination-button--next');
        if (hotspotNextButton !== null) {
            hotspotNextButton.addEventListener('click', function() {
                handleNextHotspot();
            });
        }
    });
});